import dayjs from "dayjs";
import {
  type GetAssetTimeseriesDataAssetAssetIdTimeSeriesGetQueryParams,
  timeSeriesDataProjectionEnum,
} from "kubb";
import type React from "react";
import inclusiveDatePeriod from "../../../../components/Forms/DateTimePicker";
import { parse_to_enum } from "../../../../components/Search/SearchParamPage.tsx";
import { parseSearchString } from "../../../../components/navigation/SearchString";
import { removeMapBlanks } from "../../../../utils/object.tsx";
import { SearchParamParser } from "../list/AssetListSearchParam.tsx";

export default function NewAssetDataSearchStringParser(props: {
  initialState: Partial<GetAssetTimeseriesDataAssetAssetIdTimeSeriesGetQueryParams>;
  children: React.ReactNode;
}): React.ReactElement {
  return (
    <SearchParamParser
      {...props}
      parser={(parsed) => {
        const [startDate, endDate] = inclusiveDatePeriod(
          undefined,
          undefined,
          undefined,
          true,
        );
        const searchParams = parseSearchString(location.search);

        const end_datetime = searchParams.start_datetime
          ? dayjs(searchParams.end_datetime as string)
          : dayjs(+endDate);

        const start_datetime = searchParams.start_datetime
          ? dayjs(searchParams.start_datetime as string)
          : startDate;

        return removeMapBlanks({
          start_datetime,
          end_datetime,
          projection: parse_to_enum(
            parsed,
            timeSeriesDataProjectionEnum,
            "projection",
          )?.[0],
        });
      }}
    />
  );
}
